<template>
  <base-content>
    <h3 class="tw-text-gray-700 tw-text-xl tw-font-normal">Oops! Something went wrong.</h3>
    <div class="tw-text-gray-700 tw-text-md tw-mt-2">We could not find the component you were looking for.</div>
  </base-content>
</template>

<script>
export default {
  name: "NotFoundView",
};
</script>
